import { createElement as h, useEffect, useState } from 'react';
import { memberApi } from '../api/member';
import { setStoredLocale } from '../constants/locale';
import { WEBSITE_LANGUAGES, websiteLanguages } from '../constants/websiteLanguages';
import './website-language-select.css';

/** Switch in place: never navigate, clear a form, or resubmit its request. */
export default function WebsiteLanguageSelect({ locale, t }) {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let cancelled = false;
    Promise.resolve().then(() => memberApi.listLanguages()).then(rows => {
      if (!cancelled) {
        const enabled = websiteLanguages(rows);
        setLanguages(enabled);
        setFailed(enabled.length === 0);
      }
    }).catch(() => {
      if (!cancelled) setFailed(true);
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => { cancelled = true; };
  }, []);

  const currentEnabled = languages.some(row => row.langCode === locale);
  const currentName = WEBSITE_LANGUAGES.find(row => row.langCode === locale)?.langName;
  // The shared workspace is consumed by CRA's dependency loader (no JSX transform).
  const options = languages.map(row => h('option', { key: row.langCode, value: row.langCode }, row.langName));
  if (!currentEnabled) options.unshift(h('option', { key: 'current', value: locale, disabled: true }, currentName || t('settings.languageTitle')));
  return h('span', { className: 'website-language-select' },
    h('select', {
      'aria-label': t('settings.languageTitle'),
      value: locale,
      disabled: loading || failed || languages.length === 0,
      onChange: event => {
        const next = event.target.value;
        if (languages.some(row => row.langCode === next)) setStoredLocale(next);
      },
    }, options),
    failed ? h('span', { role: 'status' }, t('settings.loadLanguagesFailed')) : null,
  );
}
